import React, { useState, useEffect } from "react";
import { Row, Col } from "shards-react";
import {
  Table1,
  Table2,
  Table3,
  Table4,
  Table5,
  Table6,
  Table7,
  Table8,
  Table9,
  Table10,
  Table11,
  Table12,
  Table13,
  Table14,
  Table15,
  Table16,
  Table17,
  Table18,
  Table19,
  Table20,
  Table21,
  Table22,
  Table23,
  Table24,
  Table25,
  Table26,
  Table27,
  Table28,
  Table29,
  Table30,
  Table31,
  Table32,
  Table33,
  Table34,
  Table35,
  Table36,
  Table37,
  Table38,
  Table39,
  Table40,
  Table41,
  Table42,
  Table43,
  Table44,
} from "views/PowerbiSetting/components";
import useCurrentUser from "shared/hook/useCurrentUser";

const KeyinAllTable = (props) => {
  const [loading, setLoading] = useState(true);
  const [yearId, setyearId] = useState(0);

  const [userType, setUserType] = useState(0);
  const { curruntUser } = useCurrentUser();

  useEffect(() => {
    setLoading(false);
    setTimeout(() => {
      if (yearId != props.yearId) {
        setyearId(props.yearId);
        setLoading(true);
      }
    }, 500);
    
  }, [props.yearId]);

  useEffect(() => {
    setyearId(props.yearId);
    setLoading(true);
    
  },[]);

  useEffect(() => {
    if (curruntUser) {
      setUserType(curruntUser.detail.userType);
    }
  }, [curruntUser]);

  return (
    <>
      {loading && (
        <Col md="12">
          {props.indicatorsDatasetSettingId == 1 ? (
            <Table1
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 2 ? (
            <Table2
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 3 ? (
            <Table3
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 4 ? (
            <Table4
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 5 ? (
            <Table5
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 6 ? (
            <Table6
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 7 ? (
            <Table7
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 8 ? (
            <Table8
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 9 ? (
            <Table9
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 10 ? (
            <Table10
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 11 ? (
            <Table11
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 12 ? (
            <Table12
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 13 ? (
            <Table13
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 14 ? (
            <Table14
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 15 ? (
            <Table15
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 16 ? (
            <Table16
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 17 ? (
            <Table17
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 18 ? (
            <Table18
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 19 ? (
            <Table19
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 20 ? (
            <Table20
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 21 ? (
            <Table21
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 22 ? (
            <Table22
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 23 ? (
            <Table23
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 24 ? (
            <Table24
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 25 ? (
            <Table25
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 26 ? (
            <Table26
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 27 ? (
            <Table27
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 28 ? (
            <Table28
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 29 ? (
            <Table29
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 30 ? (
            <Table30
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 31 ? (
            <Table31
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 32 ? (
            <Table32
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 33 ? (
            <Table33
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 34 ? (
            <Table34
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 35 ? (
            <Table35
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 36 ? (
            <Table36
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 37 ? (
            <Table37
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 38 ? (
            <Table38
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 39 ? (
            <Table39
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 40 ? (
            <Table40
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 41 ? (
            <Table41
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 42 ? (
            <Table42
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 43 ? (
            <Table43
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : props.indicatorsDatasetSettingId == 44 ? (
            <Table44
              listheadId={props.listheadId || null}
              newHeadId={props.newHeadId}
              userType={userType}
              type={props.type}
              tableTabMaster={props.tableTabMaster || false}
              tableTabSettingId={props.tableTabSettingId}
              indicatorsDatasetSettingId={props.indicatorsDatasetSettingId}
              yearId={props.yearId}
              yearNo={props.yearNo}
              agencyId={props.agencyId}
              status={props.type == "edit" ? props.status : null}
              onCeateTable={(sendData) => props.onCeateTable(sendData)}
              onApproveTable={() =>
                props.type == "edit" ? props.onApproveTable() : null
              }
            />
          ) : (
            <div> ระหว่างดำเนินการ</div>
          )}
        </Col>
      )}
    </>
  );
};

export default KeyinAllTable;
